import React from 'react';
import * as R from 'ramda';
import { SelectField, TextField } from 'react-admin';

import { surveyFeelings } from 'data';
import { NpsField, ScoreField } from './';

const AnwserField = ({ record, label, student, surveyNumber, ...rest }) => {
  switch (record.question) {
    case 'feelings':
      return (
        <SelectField
          record={record}
          source="answer"
          choices={surveyFeelings}
          {...rest}
        />
      );
    case 'prework':
    case 'challenge':
    case 'instruction':
    case 'material':
    case 'lab_preparation':
    case 'lead_teacher':
    case 'teacher_assistant':
    case 'ironhack':
    case 'ai_confidence':
    case 'v2_learning':
    case 'v2_support':
    case 'v2_sp_ai':
    case 'v2_expectations':
      return (
        <ScoreField
          record={student}
          question={record.question}
          surveyNumber={surveyNumber}
          {...rest}
        />
      );
    case 'nps':
      return (
        <NpsField
          record={student}
          question={record.question}
          surveyNumber={surveyNumber}
          {...rest}
        />
      );
    default:
      return <TextField record={record} source="answer" {...rest} />;
  }
};

const QuestionField = ({ record, questionId, surveyNumber, ...rest }) => {
  const question = R.pipe(
    R.propOr([], ['weekly_surveys']),
    R.find(({ survey }) => survey.toString() === surveyNumber),
    R.defaultTo({}),
    R.propOr([], 'answers'),
    R.find(R.propEq('question', questionId)),
    R.defaultTo({ answer: '' })
  )(record);
  return (
    <AnwserField
      record={question}
      student={record}
      surveyNumber={surveyNumber}
      {...rest}
    />
  );
};

export default QuestionField;
